import React from 'react'
import Login from '../../components/com_login';
import { reSetBar } from '../../tool/reSetBar';


export default class LoginPage extends React.Component{

    componentDidMount() {
        reSetBar()
        document.querySelector(".headerbox").parentNode.style.display = "none"

    }



    componentWillUnmount() {
        document.querySelector(".headerbox").parentNode.style.display = "block"
    }

    render(){
        return(
            <Login goLoction={()=>{window.location='/'}}/>
        )
    }
}